// Активный малый редактор (лист «Задание», «Реферат», окно раздела об ИИ): пока курсор в нём, команды ленты и
// сочетания клавиш для текста (полужирный, перечисления, уровень, отмена) работают в НЁМ, а не в основном
// документе; команды правки текста, которых в малом редакторе нет (таблица, рисунок, заголовок…), основной текст
// не трогают. Остальные команды (окна, панели, файл, вид, проверка) работают как обычно.
import type { Editor } from '@tiptap/core';

let active: Editor | null = null;
const ticks = new Set<() => void>();

export function setActiveMini(ed: Editor | null) { active = ed; ticks.forEach((f) => f()); }

/** Транзакция/фокус в малом редакторе - перерисовать ленту (доступность «Отменить», «Ж», перечисления…). */
export function miniTick() { ticks.forEach((f) => f()); }
export function onMiniTick(f: () => void): () => void { ticks.add(f); return () => { ticks.delete(f); }; }

/** Малый редактор, в котором сейчас фокус (или null). */
export function activeMini(): Editor | null {
  if (!active || active.isDestroyed) return null;
  return active.view.hasFocus() ? active : null;
}

/** Команды, которые выполняются в малом редакторе. */
export const MINI_OK = new Set([
  'format.bold', 'format.italic', 'format.underline', 'format.superscript', 'format.subscript', 'format.code', 'format.clear',
  'list.dash', 'list.letter', 'list.digit', 'list.indent', 'list.outdent', 'edit.undo', 'edit.redo', 'block.paragraph',
  'edit.selectAll',
]);

/** Команды, которые правят текст В МЕСТЕ КУРСОРА (без малого редактора - в основном документе). Структурные
 *  элементы и приложения встают на своё место по СТО - они работают и из листа задания/реферата. */
export function isTextCommand(id: string): boolean {
  return /^(insert|block|table|math|figure|code|list|format|tfc)\./.test(id)
    || ['refs.xref', 'refs.cite', 'refs.footnote', 'refs.editCite', 'edit.undo', 'edit.redo', 'edit.selectAll'].includes(id);
}
